import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import PropTypes from 'prop-types';

import { PlanTabMonth } from './PlanTabRightSectionComponents/PlanTabMonth.jsx';

const Wrapper = styled.div`
  width: 100%;
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
  background: ${themeGet('colors.white')};
`;

const PlanTabRightSectionComponent = ({
  createNewTilesDigest,
  toggleMonthCollapse,
}) => {
  const buckets = useSelector(state => state.tiles.buckets);

  return (
    <Wrapper>
      {Object.entries(buckets).map(([month, bucket], index) => (
        <PlanTabMonth
          key={index}
          month={month}
          bucket={bucket}
          createNewTilesDigest={createNewTilesDigest}
          toggleMonthCollapse={toggleMonthCollapse}
        />
      ))}
    </Wrapper>
  );
};

PlanTabRightSectionComponent.propTypes = {
  createNewTilesDigest: PropTypes.func,
  toggleMonthCollapse: PropTypes.func,
};

export default PlanTabRightSectionComponent;
